import {
    loadUsers,
    loadUser,
    createUser,
    saveUserData,
    deleteUser,
    restoreUser,
    documentsUser,
    roomsUser,
    deleteDocUser,
    deleteRoomUser,
    syncUser,
} from "@/services/users";

const state = () => ({
    usersList: [],
    currentUser: null,
    docsUser: [],
    rooms: []
});

const actions = {
    async fetchUsers({commit}, params = {}) {
        const data = await loadUsers(params);
        commit('updateUsersList', data);
    },
    async fetchUser({commit}, id) {
        const { data } = await loadUser(id);
        commit('updateCurrentUser', data);
    },
    async fetchSyncUser({commit}, id) {
        await syncUser(id);
    },
    async fetchDocsUser({commit}, payload) {
        const { data } = await documentsUser(payload.id, payload.page);
        commit('updateDocsUser', data);
    },
    async fetchRoomsUser({commit}, payload) {
        const { data } = await roomsUser(payload.id, payload.page);
        commit('updateRoomsUser', data);
    },
    async fetchSaveUserData({commit}, { id, data }) {
        await saveUserData(id, data);
    },
    async fetchCreateUser({commit}, data) {
        await createUser(data);
    },
    async fetchDeleteUser({commit}, data) {
        await deleteUser(data);
        commit('updateStatusUser', data.id)
    },
    async fetchRestoreUser({commit}, data) {
        await restoreUser(data);
        commit('updateStatusUser', data.id)
    },
    async fetchDeleteDocUser({commit, state}, payload) {
        await deleteDocUser(payload);
        if (state.docsUser.data.length - 1 > 0) {
            const { data } = await documentsUser(payload.id, state.docsUser.pagination.current_page);
            commit('updateDocsUser', data);
        } else if (state.docsUser.pagination.current_page > 1) {
            const { data } = await documentsUser(payload.id, state.docsUser.pagination.current_page - 1);
            commit('updateDocsUser', data);
        } else {
            commit('deleteDocsUsers', payload.document)
        }
    },
    async fetchDeleteRoomUser({commit, state}, payload) {
        await deleteRoomUser(payload);
        if (state.rooms.data.length - 1 > 0) {
            const { data } = await roomsUser(payload.id, state.rooms.pagination.current_page);
            commit('updateRoomsUser', data);
        } else if (state.rooms.pagination.current_page > 1) {
            const { data } = await roomsUser(payload.id, state.rooms.pagination.current_page - 1);
            commit('updateRoomsUser', data);
        } else {
            commit('deleteRoomsUser', payload.room)
        }
    },
};

const mutations = {
    updateUsersList(state, users) {
        state.usersList = users;
    },
    updateCurrentUser(state, user) {
        state.currentUser = user;
    },
    updateStatusUser(state, id) {
        if (state.usersList.data.data) {
            const findId = state.usersList.data.data.findIndex(item => item.id === id);
            if (findId !== -1) {
                state.usersList.data.data[findId].deleted = !state.usersList.data.data[findId].deleted;
            }
        }
    },
    updateDocsUser(state, docs) {
        state.docsUser = docs;
    },
    updateRoomsUser(state, rooms) {
        state.rooms = rooms;
    },
    deleteDocsUsers(state, id) {
        state.docsUser.data = state.docsUser.data.filter(item => item.id !== id);
    },
    deleteRoomsUser(state, id) {
        state.rooms.data = state.rooms.data.filter(item => item.id !== id);
    },
};

const getters = {
    getUsersList(state) {
        return state.usersList;
    },
    getCurrentUser(state) {
        return state.currentUser;
    },
    getDocsUser(state) {
        return state.docsUser;
    },
    getRoomsUser(state) {
        return state.rooms;
    }
};

export default {state, actions, mutations, getters};
